import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { MegapackMockup } from './MegapackMockup';
import { RichText } from './RichText';
import { bonuses, offerRows, volumes } from '../../data/landing';
export function Offer() {
  return <section id="oferta" aria-labelledby="offer-title" className="scroll-mt-16 bg-paper py-16 md:py-24" data-id="element-154" data-mp="3vackgpm9kmrs">
      <div className="mx-auto max-w-6xl px-5" data-id="element-155" data-mp="cwd6c5d5srbo">
        <h2 id="offer-title" className="mx-auto max-w-2xl text-center font-serif text-[2.1rem] leading-[1.08] text-ink md:text-5xl" data-id="element-156" data-mp="cv23c7rjfnlm">
          Accedé hoy al megapack completo
        </h2>

        <div className="mt-12 grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14" data-id="element-157" data-mp="mthpdwbpk6o9">
          <div className="hidden lg:block" data-id="element-158" data-mp="hwhmtve2hm1w">
            <MegapackMockup data-id="element-159" data-mp="htn2e3v2018h" />
            <div className="mt-10 grid grid-cols-2 gap-x-8 gap-y-3" data-id="element-160" data-mp="2ole1b71sfijk">
              {volumes.map(v => <p key={v.number} className="flex items-center gap-2.5 text-[15px] text-ink" data-id="element-161" data-mp="2jnmcilwfwcjl">
                  <CheckIcon className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-162" data-mp="3atimql337lqq" />
                  Tomo {v.number} — {v.title}
                </p>)}
              {bonuses.map(b => <p key={b.number} className="flex items-center gap-2.5 text-[15px] text-ink" data-id="element-163" data-mp="3jsm9q05dklai">
                  <CheckIcon className="h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-164" data-mp="3oknfd381fdrk" />
                  <span data-id="element-165" data-mp="3tk06i05xz6zy">
                    Bono {b.number}: {b.title}
                  </span>
                </p>)}
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-lg rounded-[2rem] border-2 border-primary bg-paper px-6 pb-8 pt-10 shadow-[0_30px_60px_-30px_rgba(34,48,47,0.45)] sm:px-10" data-id="element-166" data-mp="2f0dwh5bo262">
            <span className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-primary px-5 py-1.5 text-xs font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-167" data-mp="bd2if6o9lcy3">
              Contenido del megapack
            </span>

            <dl className="mb-7" data-id="element-168" data-mp="3gh7a6ilfg2hb">
              {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-line py-4" data-id="element-169" data-mp="3bhb8iq07cn4x">
                  <dt className="text-ink" data-id="element-170" data-mp="3ph2ogwaa4dlk">
                    <span className="block text-[17px] font-bold" data-id="element-171" data-mp="3pepybvudawxf">{row.label}</span>
                    <span className="mt-0.5 block text-[15px] text-muted" data-id="element-172" data-mp="3ldo09ic6sqx1">{row.detail}</span>
                  </dt>
                  <dd className="shrink-0 font-semibold text-accent" data-id="element-173" data-mp="37jd396ses5e">{row.value}</dd>
                </div>)}
            </dl>

            <div className="text-center" data-id="element-174" data-mp="czxh68lc8auq">
              <p className="text-sm font-extrabold uppercase tracking-[0.2em] text-primary/80" data-id="element-175" data-mp="cyw6w6c5bse2">Hoy</p>
              <p className="mt-2 font-serif text-6xl leading-none text-primary md:text-7xl" data-id="element-176" data-mp="814e7a3og28t">$19.990</p>
              <p className="mt-3 text-sm font-bold uppercase tracking-[0.2em] text-primary/80" data-id="element-177" data-mp="m0dgd5v1svts">ARS</p>
              <p className="mt-3 text-[15px] text-muted" data-id="element-178" data-mp="h2u3oae00r3y">
                <RichText text="[MEDIOS DE PAGO]" data-id="element-179" data-mp="10mj98n53o71g" />
              </p>

              <div className="mt-7" data-id="element-180" data-mp="15lvxncbmdm65">
                <CtaButton className="sm:w-full" data-id="element-181" data-mp="15kuj2xveahjo">Quiero mi megapack</CtaButton>
              </div>

              <p className="mt-6 text-sm leading-relaxed text-muted" data-id="element-182" data-mp="rl300iq0uayt">Descarga inmediata · 7 días de garantía</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}